import { useProperties } from '../useProperties';
import { titleToSlug } from '@/utils/shared/stringUtils';
import { useDataBySlug } from './useDataBySlug';

/**
 * Hook for finding property by slug using the generic data by slug pattern
 */
export const usePropertyBySlug = (titleSlug: string) => {
  const { data: properties = [], isLoading, error } = useProperties();

  return useDataBySlug(titleSlug, {
    data: properties,
    isLoading,
    error,
    slugExtractor: (property) => titleToSlug(property.title),
    queryKeyPrefix: 'property-by-slug',
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 20 * 60 * 1000, // 20 minutes
  });
};